<table class="table tr-table table-striped mt-5" *ngIf="hasBusinessPlanLocation && currentExports">
  <thead>
  <th scope="col">Date</th>
  <th scope="col">Time</th>
  <th scope="col">Location</th>
  <th scope="col">Data type</th>
  <th></th>
  </thead>
  <tbody>
  <tr *ngFor="let exportData of currentExports | sortByDate">
    <td>{{ exportData.exportDate | trDateFormat:'yyyy-MM-DD': timezone }}</td>
    <td>{{ exportData.exportDate | trDateFormat: 'HH:mm': timezone }}</td>
    <td>{{ getLocationNameById(exportData.restaurant) }}</td>
    <td>{{ exportData.type | titlecase }}</td>
    <td>
      <a href="{{ exportData.location }}" class="btn btn-outline-info" target="_blank" download>Download</a>
    </td>
  </tr>
  </tbody>
</table>
